import PropTypes from "prop-types"

export default function ServicesGuard({ children }) {
  return <>{children}</>
}

ServicesGuard.propTypes = {
  children: PropTypes.node
}
